import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useParams } from 'react-router';
import Card from '../../components/Card';
import Error from '../../components/Error';
import JobCardContent from '../../components/JobCardContent';
import Loading from '../../components/Loading';
import useJobs from '../../hooks/useJobs';
import Container from '../../layout/container';
import { getActiveLanguageData } from '../../utils/handleLanguage';
import { handleJobDetailQuery } from '../../utils/handleQueryString';
import classes from './style.module.scss';

export default function JobsDetail() {
  const { slug } = useParams();
  const {
    jobs: [job],
    loading,
    error
  } = useJobs(handleJobDetailQuery(slug));
  const hasError = !loading && (error || !job);
  const isDetailReady = !loading && job;

  const handleClickLinkedin = (linkedinUrl = '') => {
    window.open(linkedinUrl);
  };

  const handleClickKariyer = (kariyerUrl = '') => {
    window.open(kariyerUrl);
  };

  const handleClickApplyJob = (applyUrl = '') => {
    window.open(applyUrl);
  };

  return (
    <Container>
      {loading && <Loading />}
      {hasError && <Error />}
      {isDetailReady && (
        <Card className={classes.card}>
          <JobCardContent
            title={getActiveLanguageData({
              tr: job?.titleTR,
              en: job?.titleEN
            })}
            location={job?.location}
            date={job?.date}
            team={job?.team}
            workSchedules={job?.workSchedules}
            slug={job?.slug}
            linkedinUrl={job?.linkedinUrl}
            kariyerUrl={job?.kariyerUrl}
            applyUrl={job?.applyUrl}
            onClickLinkedin={handleClickLinkedin}
            onClickKariyer={handleClickKariyer}
            onClickApplyJob={handleClickApplyJob}
          />
          <div className={classes.detail}>
            <ReactMarkdown>
              {getActiveLanguageData({
                tr: job?.jobDetailTR,
                en: job?.jobDetailEN
              })}
            </ReactMarkdown>
          </div>
        </Card>
      )}
    </Container>
  );
}
